import {Role} from "../../domain/model/client";
import {Pager} from "../../domain/model/common";

interface IGetAllClientsByClientRequest {
    pager: Pager;
}
class GetAllClientsByClientRequest implements IGetAllClientsByClientRequest{
    public pager: Pager;
}

interface ICreateClientByClientRequest {
    name : string;
    nameKana: string;
    phoneNumber: string;
    position: string;
    email: string;
    password: string;
    role: Role;
    pager: Pager;
}
class CreateClientByClientRequest implements ICreateClientByClientRequest {
    public name : string;
    public nameKana: string;
    public phoneNumber: string;
    public position: string;
    public email: string;
    public password: string;
    public role: Role;
    public pager: Pager;
}

interface IUpdateRoleClientByClientRequest {
    clientId: string;
    role: Role;
    pager: Pager;
}
class UpdateRoleClientByClientRequest implements IUpdateRoleClientByClientRequest{
    public clientId: string;
    public role: Role;
    public pager: Pager;
}

interface IDeleteClientByClientRequest {
    clientId: string;
    pager: Pager;
}
class DeleteClientByClientRequest implements IDeleteClientByClientRequest{
    public clientId: string;
    public pager: Pager;
}

export {
    GetAllClientsByClientRequest,
    CreateClientByClientRequest,
    UpdateRoleClientByClientRequest,
    DeleteClientByClientRequest,
}


// WEBPACK FOOTER //
// ./src/presentation/request/clients_request.ts